module.exports = __webpack_public_path__ + "images/fa-regular-400.e70221c01393a280c552b46acd239071.svg";